<agr-dialog [data]="data" (cancel)="cancel()" (confirm)="updateSupplement()">
  <app-product-supplement [lineItem]="lineItem" (productSupplementsChange)="handleProductSupplementsChange($event)"></app-product-supplement>
</agr-dialog>
